import styled from "styled-components";
import { ImageWrapper } from "@/lib/styles";

export const Wrapper = styled(ImageWrapper)<{ $position?: string }>`
  width: 75%;
  padding-bottom: calc(75% * 4 / 3);
  justify-self: ${({ $position }) => ($position === "right" ? "end" : "start")};
  align-self: ${({ $position }) => ($position === "right" ? "end" : "start")};
  margin-bottom: 2.5rem;

  opacity: 0;
  transform: translateY(100px);

  ${({ theme }) => theme.mediaQueries.laptop} {
    width: 80%;
    padding-bottom: calc(80% * 4 / 3);
    grid-row-start: 1;
    grid-column-start: ${({ $position }) => ($position === "right" ? "2" : "1")};
    margin-bottom: 10rem;
  }
`;
